import axios from "axios";
import routes from "../app/routes";

export const enterpriseMembersActions = {
  loadMembers: (dispatch, enterpriseId, teamId) => {
    axios
      .get(
        routes.api.enterprises.members(enterpriseId) +
          (teamId == undefined ? "" : `?q[enterprise_team_id_eq]=${teamId}`)
      )
      .then((resp) => {
        dispatch({ type: "loadMembers", members: resp.data.data });
      });
  },
  deleteMember: (dispatch, memberId) => {
    axios.delete(routes.api.students.destroy(memberId)).then((resp) => {
      dispatch({
        type: "deleteMember",
        memberId: memberId,
      });
    });
  },
  showCredits: (dispatch, row) => {
    dispatch({ type: "showCredits", member: row });
  },
  hideCredits: (dispatch) => {
    dispatch({ type: "hideCredits" });
  },
};
